import { ComponentProps, memo, ReactElement, ReactNode } from 'react'
import cn from 'classnames'

import s from './ModalHeader.module.less'

interface IProps extends ComponentProps<'div'> {
  children: ReactNode
  additional?: ReactNode
  className?: string
  closeButton?: ReactNode
  icon?: ReactElement
  isOrder?: boolean
  isShadow?: boolean
  isSticky?: boolean
  wrapperClassName?: string
}

export const ModalHeader = memo<IProps>(function ModalHeader({
  additional,
  children,
  className,
  wrapperClassName,
  closeButton,
  icon,
  isShadow,
  isSticky,
  isOrder,
  ...rest
}) {
  return (
    <div
      {...rest}
      className={cn(s.Header, className, {
        [s.Header_sticky]: isSticky,
        [s.Header_shadow]: isSticky || isShadow
      })}
    >
      <div
        className={cn(s.wrapper, isOrder ? s.wrapper_order : '', wrapperClassName, {
          [s.wrapper_withIcon]: !!icon,
          [s.wrapper_withClose]: !!closeButton
        })}
      >
        {icon && <div className={s.iconWrapper}>{icon}</div>}
        {children}
      </div>
      {additional}
      {closeButton}
    </div>
  )
})
